import React, {useState, useRef} from 'react';
import {connect} from 'react-redux';
import ThirdParty from '../../Shared/ThirdParty/ThirdParty';
import CheckBox from '../../Shared/CheckBox/Checkbox';
import TextInput from '../../Shared/TextInput/TextInput';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import {processPhases, setCollaborationApproval, GetOrganizationList} from './ecommerceOtpSlice';
import {getReportParams, report} from '../../../middleware/report';

const SelectOrganization = (props) => {
  const [selectedOrganization, setSelectedOrganization] = useState('');
  const [collaborationApproval, setCollaborationApproval] = useState(props.authentication.loginData.userDetails.PhoneSignStatus);
  const [searchResults, setSearchResults] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isSelected, setIsSelected] = useState(false);
  const [searchPageNumber, setSearchPageNumber] = useState(1);
  const [loadMore, setLoadMore] = useState(false);
  const inputRef = useRef(null);

  async function searchOrganization(page, value) {
    // If an item was selected and the user is trying to modify it (not clear it)
    if (isSelected && value !== '' && selectedOrganization !== '' && value !== selectedOrganization) {
      // If the user is trying to delete characters (backspace/delete)
      if (value.length < searchValue.length) {
        // Allow complete clearing of the field
        if (value === '') {
          handleClearSelection();
        } else {
          // Prevent partial deletion - restore previous value
          setSearchValue(selectedOrganization);
          return;
        }
      } else {
        // Prevent adding characters - restore previous value
        setSearchValue(selectedOrganization);
        return;
      }
    }

    // Normal search behavior when not in a selected state
    setSearchValue(value);

    if (value === '') {
      // User cleared the field
      setSelectedOrganization('');
      setIsSelected(false);
      setSearchResults([]);
    } else if (value.length >= 3) {
      //get organizations from server
      props.GetOrganizationList({SearchValue: value, pageNumber: page}).then((res) => {
        if (!res.payload.error) {
          if (res.payload.data.orgList?.length > 0) {
            setSearchPageNumber(searchPageNumber + 1);
            if (page === 1) {
              setSearchResults([...res.payload.data.orgList]);
            } else {
              setSearchResults([...searchResults, ...res.payload.data.orgList]);
            }
            setLoadMore(res.payload.data.loadMore);
          } else {
            setLoadMore(false);
            setSearchResults([]);
          }
        }
      });
    } else {
      setSearchResults([]);
    }
  }

  function handleSelectItem(org) {
    setSelectedOrganization(org);
    setSearchValue(org);
    setSearchResults([]);
    setIsSelected(true);
    setErrorMessage('');
  }

  function handleClearSelection() {
    setSelectedOrganization('');
    setSearchValue('');
    setIsSelected(false);
    // Focus the input after clearing
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }

  function handleContinue() {
    if (!isSelected || !selectedOrganization) {
      setErrorMessage('יש לבחור ארגון מהרשימה');
      return;
    }

    if (collaborationApproval) {
      dwhReport();
      props.setCollaborationApproval(props.authentication.loginData.userDetails?.contactNumber);
      props.setCurrentProcessPhase(processPhases.readyToConnect);
    } else {
      //show error message
      setErrorMessage('יש לאשר את האישור לשיתוף נתונים');
    }
  }
  function dwhReport() {
    let reportParams = getReportParams();
    reportParams.area = 'Business';
    reportParams.subArea = 'Ecommerce';
    reportParams.channel = 'Website';
    reportParams.actionType = 'Choose Organization';
    reportParams.status = 'Ongoing';
    reportParams.messageText = selectedOrganization;
    reportParams.subscriber = props.authentication.loginData.userDetails?.contactNumber;
    report(reportParams);
  }

  return (
    <div className='select-organization'>
      <div className='l-title'>חיפוש ארגון</div>
      <div className='search-organization-wrapper'>
        <div className='input-container'>
          <TextInput
            ref={inputRef}
            value={searchValue}
            name='search'
            type='text'
            placeholder='שם חברה'
            onChange={(e) => searchOrganization(1, e.target.value)}
            autoComplete='off'
          />
          {isSelected && searchValue && (
            <button type='button' className='clear-button' onClick={handleClearSelection}>
              &#10005;
            </button>
          )}
        </div>
        {searchResults?.length > 0 && (
          <div className={`search-result-wrapper ${searchResults.length > 0 ? 'bordered' : ''}`}>
            {searchResults?.map((org, index) => {
              return (
                <>
                  <div className='search-result-item' onClick={() => handleSelectItem(org)} key={index}>
                    <span>{org}</span>
                  </div>
                  {index === searchResults.length - 1 && loadMore && (
                    <div
                      type='button'
                      className='search-result-item load-more-button'
                      onClick={() => searchOrganization(searchPageNumber, searchValue)}>
                      טען עוד
                    </div>
                  )}
                </>
              );
            })}
          </div>
        )}
      </div>
      {!props.authentication.loginData.userDetails.PhoneSignStatus && (
        <div className='ecommerce-checkbox'>
          <CheckBox
            id={'ecommerce'}
            onCheck={() => setCollaborationApproval(!collaborationApproval)}
            onUncheck={() => setCollaborationApproval(!collaborationApproval)}
            checked={collaborationApproval}
            label={<ThirdParty />}
          />
        </div>
      )}
      <div className='btn-submit-wrapper'>
        {errorMessage && <div className='error-message'>{errorMessage}</div>}
        <BtnSubmit disabled={!selectedOrganization} color='link' onclick={selectedOrganization ? handleContinue : null} text={'המשך'} />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    ecommerceOtp: state.ecommerceOtp,
    authentication: state.authentication,
  };
};
const mapDispatchToProps = {setCollaborationApproval, GetOrganizationList};
export default connect(mapStateToProps, mapDispatchToProps)(SelectOrganization);
